import { render, staticRenderFns } from "./edit-jianyanzu.vue?vue&type=template&id=f466bd22&scoped=true&"
import script from "./edit-jianyanzu.vue?vue&type=script&lang=ts&"
export * from "./edit-jianyanzu.vue?vue&type=script&lang=ts&"
import style0 from "./edit-jianyanzu.vue?vue&type=style&index=0&id=f466bd22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f466bd22",
  null
  
)

export default component.exports